import { CheckIcon } from '@heroicons/react/24/outline';

interface SaveProps {
  initialValue: any;
  currentValue: any;
  onClick: () => Promise<void> | void;
  isLoading?: boolean;
}

export const Save = ({
  initialValue,
  currentValue,
  onClick,
  isLoading = false,
}: SaveProps) => {
  const isObject = (value: any) => typeof value === 'object' && value !== null;

  let hasChanges;
  if (isObject(initialValue) && isObject(currentValue)) {
    hasChanges = JSON.stringify(initialValue) !== JSON.stringify(currentValue);
  } else {
    hasChanges = initialValue !== currentValue;
  }

  const isButtonActive = hasChanges && !isLoading;
  const isButtonDisabled = !hasChanges || isLoading;

  return (
    <button
      className={`flex flex-row justify-center items-center mt-2 rounded-2xl p-2 w-24 self-end transition-colors duration-150 ${
        isButtonActive
          ? 'bg-yellow text-black hover:brightness-90 active:brightness-75'
          : 'bg-white bg-opacity-10 text-white cursor-not-allowed'
      }`}
      onClick={onClick}
      disabled={isButtonDisabled}
    >
      {isLoading ? (
        <svg
          className="animate-spin h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      ) : (
        <>
          Save
          <CheckIcon className="w-4 h-4 ml-2" />
        </>
      )}
    </button>
  );
};
